import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../src/pages/home.vue'
import Login from '../src/pages/login.vue'
import Tool from '../src/pages/main/tool.vue'
import AboutWebsite from '../src/pages/main/aboutWebsite.vue'
import Gpt from '../src/pages/content/gpt.vue'
import Dev from '../src/pages/main/dev.vue'
import Video from '../src/pages/main/video.vue'
import Chatgpt from '../src/pages/main/chatgpt.vue'
import Live from '../src/pages/main/live.vue'
import FriendLinks from '../src/pages/main/friendLinks.vue'
import Game from '../src/pages/main/game.vue'
import CloudServer from '../src/pages/main/cloudServer.vue'
import Comment from '../src/pages/main/comment.vue'
import QueryIp from '../src/pages/tool/queryIp.vue'
import GenerateCode from '../src/pages/tool/generateCode.vue'
import Questionnaire from '../src/pages/tool/questionnaire.vue'
import NesGame from '../src/pages/tool/nesGame.vue'
import Detail from '../src/pages/detail.vue'
Vue.use(VueRouter)
const route=new VueRouter({
	
	routes:[
		{
			name:'login',
			component: Login,
			path:"/"
		},
		{
			name:'detail',
			component: Detail,
			path:"/detail"
		},
		{
			name:'home',
			component: Home,
			path:"/home",
			children:[
				{
					name:'tool',
					component: Tool,
					path:"/tool"
				},
				{
					name:'aboutWebsite',
					component:AboutWebsite,
					path:"/aboutWebsite"
					
				},
				{
					name:'gpt',
					component: Gpt,
					path:"/gpt"
				},
				{
					name:'dev',
					component: Dev,
					path:"/dev"
				},
				{
					name:'video',
					component: Video,
					path:"/video"
				},
				{
					name:'game',
					component: Game,
					path:"/game"
				},
				{
					name:'cloudServer',
					component: CloudServer,
					path:"/cloudServer"
				},
				{
					name:'comment',
					component: Comment,
					path:"/comment"
				},
				{
					name:"queryIp",
					component:QueryIp,
					path:'/queryIp'
				},{
					name:"generateCode",
					component:GenerateCode,
					path:'/generateCode'
				},{
					name:"questionnaire",
					component:Questionnaire,
					path:'/questionnaire'
				}
				,{
					name:"nesGame",
					component:NesGame,
					path:'/nesGame'
				}
				,{
					name:"chatgpt",
					component:Chatgpt,
					path:'/chatgpt'
				},{
					name:"friendLinks",
					component:FriendLinks,
					path:'/friendLinks'
					
				}
				,{
					name:"live",
					component:Live,
					path:'/live'
					
				}
			]
		},
		
	]
})

export default route